import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { GET_INSURANCE_CARRIERS } from "./actionTypes"
import {
  getInsuranceCarriersSuccess, getInsuranceCarriersError
} from "./actions"

import { genericGetRequest } from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"

function* onGetCarriers() {
  try {
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/insurance_carriers`,
      {}, // no query parameters
      {
        'Content-Type': 'application/json',
      }
    )
    yield put(getInsuranceCarriersSuccess(response))
  } catch (error) {
    yield put(getInsuranceCarriersError(error))
  }
}

function* InsuranceCarriersSaga() {
  yield takeEvery(GET_INSURANCE_CARRIERS, onGetCarriers)
}

export default InsuranceCarriersSaga
